module.exports = __webpack_public_path__ + "media/images/proof_links/goodreads-867524241a6c14f7f6baef3730b6a1f1.svg";